/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddFreeTicketRequestApiFrom } from '../../models/add-free-ticket-request-api-from';
import { AddFreeTicketResponseApiFrom } from '../../models/add-free-ticket-response-api-from';

export interface ApiV3ServiceAddFreeTicketPost$Plain$Params {

/**
 * *	language code
 */
  lang?: string;
      body?: AddFreeTicketRequestApiFrom
}

export function apiV3ServiceAddFreeTicketPost$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceAddFreeTicketPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddFreeTicketResponseApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceAddFreeTicketPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddFreeTicketResponseApiFrom>;
    })
  );
}

apiV3ServiceAddFreeTicketPost$Plain.PATH = '/api/v3/service/AddFreeTicket';
